"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItmFieldMapping = exports.ItmFieldName = void 0;
var ItmFieldName;
(function (ItmFieldName) {
    ItmFieldName["issueToManagementRecordID"] = "issueToManagementRecordID";
    ItmFieldName["approvedTimestamp"] = "approvedTimestamp";
    ItmFieldName["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ItmFieldName["notApprovedTimestamp"] = "notApprovedTimestamp";
    ItmFieldName["referenceNumber"] = "referenceNumber";
    ItmFieldName["statusCode"] = "statusCode";
    ItmFieldName["deleteFlag"] = "deleteFlag";
    ItmFieldName["typeCodes"] = "typeCodes";
})(ItmFieldName = exports.ItmFieldName || (exports.ItmFieldName = {}));
var ItmFieldMapping;
(function (ItmFieldMapping) {
    ItmFieldMapping["issueToManagementRecordID"] = "issueToManagementRecordID";
    ItmFieldMapping["approvedTimestamp"] = "approvedTimestamp";
    ItmFieldMapping["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ItmFieldMapping["notApprovedTimestamp"] = "notApprovedTimestamp";
    ItmFieldMapping["referenceNumber"] = "referenceNumber";
    ItmFieldMapping["statusCode"] = "statusCode";
    ItmFieldMapping["deleteFlag"] = "deleteFlag";
    ItmFieldMapping["typeCodes"] = "typeCodes";
})(ItmFieldMapping = exports.ItmFieldMapping || (exports.ItmFieldMapping = {}));
